/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Leaf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Leaf"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#1D5A53"
        d="M6.32 7.188c4.774-4.703 11.755-4.544 15.262-3.776.779 3.456.941 10.335-3.832 15.038-4.473 4.407-8.489 2.185-10.74.15q-.37.28-.773.551-.713.49-1.402.79-.69.312-1.222.3-.702-.015-1.163-.45A1.3 1.3 0 0 1 2 18.763a1 1 0 0 1 .184-.55q.176-.244.56-.354a32 32 0 0 0 1.96-.63q.389-.134.752-.296c-1.783-2.302-3.091-5.847.864-9.745"
      />
      <path
        fill="#4BA279"
        d="M18.01 8.34a1.02 1.02 0 0 1-1.429 0 .985.985 0 0 1 0-1.408 1.02 1.02 0 0 1 1.429 0 .985.985 0 0 1 0 1.408m-5 9.15a1.02 1.02 0 0 1-1.43 0 .985.985 0 0 1 0-1.407 1.02 1.02 0 0 1 1.43 0 .985.985 0 0 1 0 1.407m-4.287-4.223a1.02 1.02 0 0 1-1.429 0 .985.985 0 0 1 0-1.408 1.02 1.02 0 0 1 1.429 0 .985.985 0 0 1 0 1.408m7.858.703a1.02 1.02 0 0 1-1.429 0 .985.985 0 0 1 0-1.407 1.02 1.02 0 0 1 1.429 0 .985.985 0 0 1 0 1.408m-4.286-4.224a1.02 1.02 0 0 1-1.43 0 .985.985 0 0 1 0-1.407 1.02 1.02 0 0 1 1.43 0 .985.985 0 0 1 0 1.407"
      />
    </g>
  </svg>
);

export const LeafIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'leaf-icon'}
      icon={Leaf}
      {...props}
      size={size}
    />
  );
};
